const ENV = {
    OPTIMIZELY_KEY: 'HiuzBL1MFGx4iTwGajvQ1',
};

export { ENV };
//# sourceMappingURL=environment.prod.js.map
